export const APP_NAME = 'FIUHB';

// Logo Assets - Change these paths to update logos across the entire app
export const LOGO_ICON = require('../assets/FIUHB_ICON.png');
export const LOGO_FAVICON = '/fiuhbicon.png'; // Located in public folder

// export const API_BASE_URL = "http://127.0.0.1:8000/api";
export const API_BASE_URL = "https://api-fiuhb.onpousse.com/api";